import palette from './palette';

const typography = {
  body1: {
    color: palette.text.primary,
    fontFamily: 'Gothic A1',
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: 0.5,
    lineHeight: 'normal',
  },
  body1bold: {
    color: palette.text.primary,
    fontFamily: 'Gothic A1',
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: 0.5,
    lineHeight: 'normal',
  },
  body2: {
    color: palette.text.primary,
    fontFamily: 'Gothic A1',
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.25,
    lineHeight: 'normal',
  },
  body3: {
    color: palette.text.primary,
    fontFamily: 'Overpass',
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.25,
    lineHeight: 'normal',
  },
  button: {
    fontFamily: 'Overpass',
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.75,
    lineHeight: '20px',
    textTransform: 'none',
  },
  caption: {
    color: palette.text.secondary,
    fontFamily: 'Gothic A1',
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 0.4,
    lineHeight: 'normal',
  },
  dropdown: {
    color: palette.text.primary,
    fontFamily: 'Gothic A1',
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: 0.5,
    lineHeight: 'normal',
  },
  h1: {
    color: palette.primary.dark,
    fontFamily: 'Overpass',
    fontSize: 96,
    fontWeight: 400,
    letterSpacing: -0.5,
    lineHeight: 'normal',
  },
  h2: {
    color: palette.primary.dark,
    fontFamily: 'Gothic A1',
    fontSize: 64,
    fontWeight: 400,
    letterSpacing: -0.5,
    lineHeight: 'normal',
  },
  h3: {
    color: palette.primary.dark,
    fontFamily: 'Overpass',
    fontSize: 48,
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: 'normal',
  },
  h4: {
    color: palette.primary.dark,
    fontFamily: 'Gothic A1',
    fontSize: 32,
    fontWeight: 700,
    letterSpacing: 0.25,
    lineHeight: 'normal',
  },
  h5: {
    color: palette.primary.dark,
    fontFamily: 'Overpass',
    fontSize: 24,
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: 'normal',
  },
  h6: {
    color: palette.primary.dark,
    fontFamily: 'Overpass',
    fontSize: 20,
    fontWeight: 700,
    letterSpacing: 0.25,
    lineHeight: 'normal',
  },
  h7: {
    color: palette.text.primary,
    fontFamily: 'Gothic A1',
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: 0.5,
    lineHeight: 'normal',
  },
  label: {
    color: palette.text.secondary,
    fontFamily: 'Overpass',
    fontSize: 18,
    fontWeight: 400,
    letterSpacing: 0.25,
    lineHeight: 'normal',
  },
  link: {
    color: palette._next.blue.main,
    fontFamily: 'Gothic A1',
    fontSize: 14,
    fontWeight: 400,
    textDecoration: 'underline dotted',
  },
  subtitle1: {
    color: palette.text.secondary,
    fontFamily: 'Overpass',
    fontSize: 18,
    fontWeight: 400,
    letterSpacing: 0.25,
    lineHeight: 'normal',
  },
  subtitle2: {
    color: palette.text.primary,
    fontFamily: 'Overpass',
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 0.1,
    lineHeight: 'normal',
  },
  tab: {
    color: palette.text.secondary,
    fontFamily: 'Overpass',
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.75,
    lineHeight: 'normal',
  },
};

export default typography;
